import { Box, Typography } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var IntroPortalFeatureCard = function IntroPortalFeatureCard(props) {
  var item = props.item;
  return /*#__PURE__*/_jsxs(Box, {
    className: "flex h-full flex-col items-center space-y-5",
    children: [/*#__PURE__*/_jsx(Box, {
      className: "aspect-[3/2] w-full overflow-hidden rounded-3xl bg-[#006DB029]",
      children: item.imageUrl && /*#__PURE__*/_jsx(Box, {
        className: "flex h-full w-full justify-center px-5 pt-5",
        children: /*#__PURE__*/_jsx(Box, {
          component: "img",
          src: item.imageUrl,
          alt: item.title,
          className: "h-full w-auto object-contain"
        })
      })
    }), /*#__PURE__*/_jsxs(Box, {
      className: "flex flex-col items-center space-y-3 text-center",
      children: [/*#__PURE__*/_jsx(Typography, {
        className: "font-['Playfair_Display',serif] text-2xl font-black leading-snug text-[#202020] md:text-[26px]",
        children: item.title
      }), /*#__PURE__*/_jsx(Typography, {
        className: "text-base font-medium leading-7 text-[#202020] md:text-lg",
        children: item.desc
      })]
    })]
  });
};

export default IntroPortalFeatureCard;